import React from "react";
import { Container, Flex, Heading, Text } from "@chakra-ui/react";
import MemberHeroSection from "@/components/membership/MemberHeroSection";

const linksData = [
	{
		id: "SEBI_AI_SIMPLIFICATION",
		date: "18th December 2023",
		text: "SEBI Circular: Simplification of requirements for grant of accreditation to investors",
		link: "https://static.levocdn.com/WGLBUT82/SEBI-AI-Simplification-7155450642275085256.pdf",
	},
];

const AccreditedInvestor = () => (
	<Flex direction="column" rowGap="20px">
		<MemberHeroSection
			title={
				<Heading
					as="h1"
					variant="headingText"
					color="text.headingWhite"
					fontSize={{ xs: "36px", sm: "60px", md: "74px" }}
					textAlign={{ xs: "left", sm: "left" }}
				>
					Accredited Investor
				</Heading>
			}
			type="about-us"
		/>
		<Container
			maxW="container.xl"
			pt={{ xs: "50px", md: "50px" }}
			pb={{ xs: "50px", md: "50px" }}
			as="section"
			id="info"
			scrollMarginTop="140px"
		>
			<Flex direction="column" gap="2">
				{linksData.map((item) => (
					<Flex
						key={item.id}
						direction={{ base: "column", md: "row" }}
						cursor="pointer"
						gap={{ md: "5" }}
						onClick={() => {
							window.open(item?.link, "_blank");
						}}
					>
						<Flex minWidth="200px">
							<Text
								cursor="pointer"
								// variant="infoText"
								variant="heroDesc"
								color="text.mediumBlackAlpha"
								_hover={{
									textDecoration: "underline",
								}}
							>
								{item?.date}
							</Text>
							<Text
								display={{ base: "block", md: "none" }}
								cursor="pointer"
								// variant="infoText"
								variant="heroDesc"
								color="text.mediumBlackAlpha"
								_hover={{
									textDecoration: "underline",
								}}
							>
								:&nbsp;
							</Text>
						</Flex>
						<Flex>
							<Text
								display={{ base: "none", md: "block" }}
								cursor="pointer"
								// variant="infoText"
								variant="heroDesc"
								color="text.mediumBlackAlpha"
								_hover={{
									textDecoration: "underline",
								}}
							>
								:&nbsp;
							</Text>
							<Text
								cursor="pointer"
								// variant="infoText"
								variant="heroDesc"
								color="text.mediumBlackAlpha"
								_hover={{
									textDecoration: "underline",
								}}
							>
								{item.text}
							</Text>
						</Flex>
					</Flex>
				))}
			</Flex>
		</Container>
	</Flex>
);

export default AccreditedInvestor;
